import React, { useEffect, useState } from "react";
import { Modal, Radio } from "antd";

import { useForm } from "antd/es/form/Form";
import DoctorService from "../../../Services/DoctorService";
import person from "../../../Assets/Icons/person.svg";
import NewPatientInvite from "../Dashboard/NewPatientInvite";
import ExistingPatient from "../Dashboard/ExistingPatient";
import Invitelink from "../../../Assets/Images/Invitelink.svg";
import Invite from "../../../Assets/Images/Invite.svg";

function NewInviteCard({ appointmentsList }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [accountDetails, setAccountDetails] = useState({});

  const [form] = useForm();

  const [mobileNumber, setMobileNumber] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [radioValue, setRadioValue] = useState("newPatient");

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const onChange = (e) => {
    setRadioValue(e.target.value);
    form.resetFields();
    setIsVisible(false);
    setMobileNumber("");
  };

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0", "1", "2", "3", "4", "5", "6", "7", "8", "9",
      "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab",
    ];

    if (e.ctrlKey || e.metaKey) return;

    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }

    if (!isNaN(e.key) && e.target.value.length >= 12) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    appointmentsList();
    getAccountDetails();
  }, []);

  const getAccountDetails = async () => {
    DoctorService.getHospitalAccountData(loginResultObject.user.account_Id)
      .then((res) => {
        setAccountDetails(res.data[0]);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const showModal = () => setIsModalOpen(true);

  const handleOk = () => {
    form.resetFields();
    setIsModalOpen(false);
    setMobileNumber("");
    appointmentsList();
    setRadioValue("newPatient");
  };

  const handleCancel = () => {
    form.resetFields();
    setMobileNumber("");
    setIsModalOpen(false);
    setIsVisible(false);
    setRadioValue("newPatient");
  };

  return (
    <>
      <div
        className="bg-white rounded-md w-full max-w-[304px] h-[46px] flex items-center cursor-pointer justify-center text-center gap-2 px-3"
        onClick={showModal}
      >
        <img src={person} alt="" className="w-6 h-6" />
        <p className="mt-4 font-sans font-medium text-sm text-[#333333]">
          Invite a patient for a consultation
        </p>
      </div>

      <style>{`
        /* Modal: full-screen on mobile */
        @media (max-width: 640px) {
          .invite-modal .ant-modal {
            max-width: 100vw !important;
            width: 100vw !important;
            margin: 0 !important;
            padding: 0 !important;
            top: 0 !important;
          }
          .invite-modal .ant-modal-content {
            border-radius: 0 !important;
            min-height: 100dvh;
          }
          .invite-modal .ant-modal-body {
            padding: 12px !important;
            overflow-y: auto;
          }
          .invite-modal .ant-modal-header {
            padding: 12px 16px !important;
          }
 
          /* Header banner: hide the decorative image on mobile */
          .invite-modal-header-banner {
            flex-direction: column !important;
            gap: 8px !important;
          }
          .invite-modal-header-banner .invite-banner-img {
            display: none !important;
          }
 
          /* Radio group: stack vertically on very small screens */
          .invite-modal .custom-radio {
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: wrap !important;
            gap: 8px !important;
          }
 
          /* Form rows: stack fields instead of side-by-side */
          .invite-modal .ant-row {
            flex-direction: column !important;
          }
          .invite-modal .ant-col {
            max-width: 100% !important;
            width: 100% !important;
            flex: 0 0 100% !important;
          }
 
          /* Full-width inputs & selects */
          .invite-modal .ant-input,
          .invite-modal .ant-input-affix-wrapper,
          .invite-modal .ant-select,
          .invite-modal .ant-picker,
          .invite-modal .ant-select-selector {
            width: 100% !important;
            min-width: 0 !important;
          }
 
          /* Payment row: wrap when cramped */
          .invite-modal .payment-row {
            flex-wrap: wrap !important;
            gap: 8px !important;
          }
          .invite-modal .payment-row > * {
            min-width: 0 !important;
            flex: 1 1 140px !important;
          }
 
          /* Submit / action buttons: full width */
          .invite-modal .ant-modal-footer button,
          .invite-modal .invite-action-btn {
            width: 100% !important;
            margin-inline-start: 0 !important;
          }
        }
 
        /* Tablet: slightly less aggressive adjustments */
        @media (min-width: 641px) and (max-width: 900px) {
          .invite-modal .ant-modal {
            width: 90vw !important;
            max-width: 90vw !important;
          }
        }
      `}</style>

      <Modal
        wrapClassName="invite-modal"
        title={
          <div className="flex items-center border-brand-colorBorder pb-4">
            <h3 className="mb-0 text-sm font-semibold tracking-wider ml-3">
              Invite a patient for a consultation
            </h3>
          </div>
        }
        footer={[]}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width="50%"
        height="10%"
        style={{
          top: 20,
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <div className="border">
          <div className="bg-[#F6FEFF] h-auto min-h-[7rem] p-3 border-b">
            <div
              className="invite-modal-header-banner flex justify-between items-center"
            >
              <div>
                <div className="flex gap-2">
                  <img src={Invitelink} alt="img" className="w-6 h-6" />
                  <span>Invite Link</span>
                </div>
                {/* <div className="mt-4">
                  <Radio.Group
                    onChange={onChange}
                    value={radioValue}
                    className="custom-radio"
                  >
                    <Radio value={"newPatient"}>Quick Invite</Radio>
                    <Radio value={"existingPatient"}>Existing Patient</Radio>
                  </Radio.Group>
                </div> */}
              </div>
              <img
                src={Invite}
                alt="img"
                className="invite-banner-img w-32 h-20"
              />
            </div>
          </div>

          {radioValue === "newPatient" ? (
            <NewPatientInvite
              form={form}
              handleOk={handleOk}
              handleKeyPress={handleKeyPress}
              appointmentsList={appointmentsList}
              accountDetails={accountDetails}
              setRadioValue={setRadioValue}
              setMobileNumber={setMobileNumber}
            />
          ) : (
            <ExistingPatient
              form={form}
              handleOk={handleOk}
              handleKeyPress={handleKeyPress}
              appointmentsList={appointmentsList}
              setMobileNumber={setMobileNumber}
              mobileNumber={mobileNumber}
              radioValue={radioValue}
              isVisible={isVisible}
              setIsVisible={setIsVisible}
              setRadioValue={setRadioValue}
            />
          )}
        </div>
      </Modal>
    </>
  );
}

export default NewInviteCard;